import { graphql } from '@gql';

export const GET_TRAS_FOR_PROJECT = graphql(`
    query trasForProject($pid: ID!) {
        tras(where: { projectID: $pid }) {
            edges {
                node {
                    ...TraBasePartial
                    metadata
                }
            }
        }
    }
`);

export const GET_TRA = graphql(`
    query tra($id: ID!) {
        tras(where: { id: $id }) {
            edges {
                node {
                    ...TraPartial
                }
            }
        }
    }
`);

export const GET_TRA_HISTORY = graphql(`
    query traHistory($id: ID!) {
        tras(where: { id: $id }) {
            edges {
                node {
                    id
                    history {
                        id
                        createTime
                        status
                        comment
                        user {
                            id
                            firstName
                            lastName
                        }
                    }
                }
            }
        }
    }
`);

export const SET_TRA_PARTICIPANTS = graphql(`
    mutation setTRAParticipants($id: ID!, $participants: [ID!]) {
        setTRAParticipants(input: { id: $id, userIDs: $participants }) {
            id
            user {
                id
                firstName
                lastName
            }
        }
    }
`);

export const UPDATE_TRA = graphql(`
    mutation updateTRA($input: UpdateTRARawInput!) {
        updateTRA(input: $input) {
            ...TraBasePartial
        }
    }
`);

export const SET_TRA_STATE = graphql(`
    mutation setTRAState(
        $id: ID!
        $state: TRASetStateStatus!
        $comment: String
    ) {
        setTRAState(traID: $id, state: $state, comment: $comment) {
            id
            status
        }
    }
`);

export const GET_TRA_TEMPLATE_VARIANTS = graphql(`
    query traTemplateVariants {
        traTemplateVariants
    }
`);

export const GET_TRA_TEMPLATE_BY_VARIANT = graphql(`
    query traTemplateByVariant($variant: String!) {
        traTemplateLatestForVariant(variant: $variant) {
            id
            createTime
            title
            description
            variant
            body
        }
    }
`);

export const GET_LATEST_ATTCK = graphql(`
    query latestAttck {
        attckLatest {
            id
            createTime
            version
            url
            domain
            assets {
                id
                name
                description
                label
                srcId
                url
            }
            techniques {
                id
                name
                srcId
                description
                label
                url
                techniqueAssets {
                    id
                    asset {
                        id
                    }
                }
                techniqueMitigations {
                    id
                    description
                    srcId
                    mitigation {
                        id
                        name
                        label
                        description
                        srcId
                        url
                    }
                }
            }
            tactics {
                id
                name
                label
                description
                srcId
                url
                techniques {
                    id
                }
            }
        }
    }
`);

export const GET_LATESTS_ATTCK = graphql(`
    query listAttcks {
        attcks {
            edges {
                node {
                    id
                    version
                    createTime
                    domain
                    assets {
                        id
                        name
                        label
                        description
                    }
                    tactics {
                        id
                        name
                        label
                        description
                        techniques {
                            label
                            description
                            techniqueMitigations {
                                id
                                mitigation {
                                    name
                                    description
                                    label
                                }
                            }
                        }
                    }
                    techniques {
                        id
                        name
                        description
                        url
                        techniqueMitigations {
                            id
                            description
                            mitigation {
                                name
                                description
                                label
                            }
                        }
                    }
                }
            }
        }
    }
`);

export const LOCK_TRA = graphql(`
    mutation lockTRA($id: ID!) {
        lockTRA(traID: $id) {
            id
            status
            lockedAt
            lockedBy {
                id
                firstName
                lastName
            }
        }
    }
`);

export const UNLOCK_TRA = graphql(`
    mutation unlockTRA($id: ID!) {
        unlockTRA(traID: $id) {
            id
            status
            lockedAt
            lockedBy {
                id
                firstName
                lastName
            }
        }
    }
`);

export const GET_TRA_REPORT_CONTENT = graphql(`
    query downloadTRAReportContent($id: ID!) {
        downloadTRAReportContent(traReportID: $id) {
            content
            type
            fileName
        }
    }
`);
